<template>
  <el-popover
    placement="bottom-end"
    :width="300"
    trigger="click"
    :show-arrow="false"
    popper-style="padding: 0; border-radius: 12px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);"
    popper-class="v4-apps-popover"
  >
    <template #reference>
      <button
        type="button"
        class="relative inline-flex items-center justify-center w-9 h-9 rounded-full text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors focus:outline-none"
      >
        <span class="sr-only">View Apps</span>
        <ViewGridIcon class="w-5 h-5" aria-hidden="true" />
      </button>
    </template>

    <template #default>
      <div class="flex flex-col bg-white">
        <div class="px-4 py-3 border-b border-gray-100">
          <h2 class="text-sm font-semibold text-gray-900">Apps</h2>
        </div>

        <div class="p-2">
          <div v-if="loading" class="grid grid-cols-3 gap-1 p-2">
            <div
              v-for="n in 6"
              :key="n"
              class="flex flex-col items-center gap-2 px-2 py-3"
            >
              <el-skeleton-item variant="image" class="!w-10 !h-10 !rounded-lg" />
              <el-skeleton-item variant="text" class="!w-10 !h-2" />
            </div>
          </div>

          <div v-else-if="apps.length > 0" class="grid grid-cols-3 gap-1">
            <a
              v-for="app in apps"
              :key="app.link"
              :href="app.link"
              target="_blank"
              rel="noopener"
              class="flex flex-col items-center gap-2 rounded-lg px-2 py-3 text-center hover:bg-gray-50 transition-colors"
            >
              <img
                class="w-10 h-10 rounded-lg object-cover"
                :src="app.cover_photo"
                :alt="app.name"
              />
              <span class="text-xs font-medium text-gray-700 leading-tight line-clamp-2">
                {{ app.name }}
              </span>
            </a>
          </div>

          <div v-else class="py-6">
            <el-empty :image-size="64" description="No apps available" />
          </div>
        </div>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { http } from "@/composable/httpService";
import { ElPopover, ElSkeletonItem, ElEmpty } from "element-plus";
import { ViewGridIcon } from "@heroicons/vue/outline";
import { onMounted, ref } from "vue";

const apps = ref([]);
const loading = ref(true);

const fetchApps = async () => {
  loading.value = true;
  try {
    const { data } = await http().get("/central/get-app-menu");
    apps.value = data;
  } catch (error) {
    console.error("Error fetching apps:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(fetchApps);
</script>
